import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { FaPlus, FaFlask } from 'react-icons/fa';
import LabTable from '../../components/labs/LabTable';
import LabModal from '../../components/labs/LabModal';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import Layout from '../../components/layouts/Main';

const LabsPage = () => {
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editLab, setEditLab] = useState(null);

  useEffect(() => {
    fetchLabs();
  }, []);

  const fetchLabs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.API_BASE_URL}/labs`);
      setLabs(response.data);
    } catch (error) {
      console.error('Error fetching labs:', error);
      toast.error('Failed to load labs');
    } finally {
      setLoading(false);
    }
  };

  const handleAddLab = () => {
    setEditLab(null);
    setShowModal(true);
  };

  const handleEditLab = (lab) => {
    setEditLab(lab);
    setShowModal(true);
  };

  const handleDeleteLab = async (lab) => {
    if (!window.confirm(`Are you sure you want to delete lab "${lab.name}"?`)) {
      return;
    }

    try {
      await axios.delete(`${config.API_BASE_URL}/labs/${lab._id}`);
      toast.success('Lab deleted successfully');
      fetchLabs();
    } catch (error) {
      console.error('Error deleting lab:', error);
      const errorMessage = error.response?.data?.message || 'Failed to delete lab';
      toast.error(errorMessage);
    }
  };

  const handleViewLab = (lab) => {
    // Could implement a view modal here if needed
    console.log('View lab:', lab);
  };

  const handleLabSaved = () => {
    fetchLabs();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditLab(null);
  };

  return (
    <Layout>
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-1">
                <FaFlask className="me-2 text-primary" />
                Lab Management
              </h2>
              <p className="text-muted mb-0">Manage laboratory information for QC testing</p>
            </div>
            <Button
              variant="primary"
              onClick={handleAddLab}
              className="d-flex align-items-center"
            >
              <FaPlus className="me-2" />
              Add Lab
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading labs...</p>
                </div>
              ) : labs.length === 0 ? (
                <Alert variant="info" className="text-center">
                  <FaFlask className="me-2" />
                  No labs found. Click "Add Lab" to create your first lab.
                </Alert>
              ) : (
                <LabTable
                  labs={labs}
                  onEdit={handleEditLab}
                  onDelete={handleDeleteLab}
                  onView={handleViewLab}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <LabModal
        show={showModal}
        onHide={handleCloseModal}
        onLabSaved={handleLabSaved}
        editLab={editLab}
      />
    </Layout>
  );
};

export default LabsPage;
